import { useContext } from "react";
import CompanyContext from "contexts/CompanyContext";

/**
 * Id firmy aktywnej jako segment klucza React Query. Dane per-firmę (np. FK, kontrahenci)
 * muszą być zawężone przez `WorkspaceId` — dołączenie go do queryKey sprawia, że gdyby
 * kiedyś zmienił się kontekst firmy w trakcie sesji, React Query natychmiast zwróci dane
 * nowej firmy zamiast trzymać w oknie refetchu dane poprzedniej.
 *
 * Następca `useCurrentProfileId` z modelu profili — D1 (jedna firma na użytkownika, bez
 * przełącznika) sprawia, że wartość w praktyce nie zmienia się w trakcie sesji, ale
 * zależność zostaje jako niegroźny backstop i jedyne miejsce, które trzeba by dotknąć,
 * gdyby to się kiedyś zmieniło.
 *
 * Pusty string = brak aktywnej firmy (przed hydratacją albo konto bez firmy, D2).
 */
const useCurrentCompanyId = (): string => {
  const { company } = useContext(CompanyContext);
  return company?.Id ?? "";
};

export default useCurrentCompanyId;
